import React from 'react';
import { Hero } from './components/Hero';
import { PainAndProduct } from './components/PainProduct';
import { TomosAndBonos } from './components/TomosBonos';
import { Precios } from './components/Precios';
import { TestimonialsAndFaq } from './components/TestimonialsFaq';
import { CtaAndFooter } from './components/Footer';
import { StickyCTA } from './components/Shared';
import { SocialProofToast } from './components/SocialProofToast';
import { UrgencyBanner } from './components/UrgencyBanner';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-base font-sans text-brand-text selection:bg-brand-orange selection:text-white pb-20 md:pb-0" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBanner data-id="element-2" />
      <Hero data-id="element-3" />
      <PainAndProduct data-id="element-4" />
      <TomosAndBonos data-id="element-5" />
      <Precios data-id="element-6" />
      <TestimonialsAndFaq data-id="element-7" />
      <CtaAndFooter data-id="element-8" />
      <StickyCTA data-id="element-9" />
      <SocialProofToast data-id="element-10" />
    </div>;
}